<template>
    <div class="barocare-b2c-popup" id="barocare-b2c-popup">
        <div class="wrapper" v-if="view">
            <a href="https://smore.im/form/jJRdZnTfyc" target="_blank" title="새창">
                <img class="img" src="../../assets/pc_barocare_b2c/img-popup.jpg" alt="연락처만 남겨도 커피 쿠폰 100% 증정(상세내용 다음 참고)"/>
                <div class="sr-only">
                    <h2>연락처만 남겨도 커피 쿠폰 100% 증정</h2>
                    <p>링크를 통해 연락처를 남겨주시면 <strong>커피 쿠폰 100% 증정</strong></p>
                    <p>장애인 또는 장애인의 가족구성원만 이벤트에 참여할 수 있습니다.</p>
                    <strong>커피 쿠폰 받으러 가기</strong>
                </div>
            </a>
            <div class="btn-area">
                <span class="btn-today-close">
                    <input type="checkbox" id="inputId1" v-model="todayChecked" class="checkbox">
                    <label for="inputId1" class="label">오늘 하루 보이지 않음</label>
                </span>
                <button type="button" :class="['btn-close', pageButtonClass]" @click="close" title="닫기"></button>
            </div>
        </div>
    </div>
</template>

<script>
import cookies from "@/utilities/cookie.js";

export default {
    name: "BarocareB2cPopup",
    data: function() {
        return {
            view: true,
            todayChecked: false
        };
    },
    props: {
        pageButtonClass: {
            type: String,
            default: ""
        }
    },
    mounted: function() {
        const todayCookie = cookies.getCookie("today");
        if (todayCookie) {
            const currentDate = new Date();
            const savedDate = new Date(todayCookie);

            if (currentDate < savedDate) {
                this.view = false;
            }
        }
    },
    methods: {
        close: function() {
            if (this.todayChecked) {
                const currentDate = new Date();
                // 오늘 날짜의 한국 시간 23:59:59로 설정
                const expireDate = new Date(currentDate.getTime() + (9 * 60 * 60 * 1000));
                expireDate.setHours(23, 59, 59, 999);
                cookies.setCookie("today", expireDate.toUTCString());
            }
            this.view = false;
        }
    }
};
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/pc_barocare_b2c/BarocareB2cPopup.vue